{
	"title": "Създай декларация",
	"backLinkToMaterialDetailsTitle": "Назад към Детайли за материал",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Назад към {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Назад към Управление на декларации",
	"steps": {
		"firstStep": {
			"title": "Стъпка 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Стъпка 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Стъпка 3",
			"label": "3"
		}
	}
}
